import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { value: null }
const _hoisted_2 = ["value"]

import { watch, reactive, onMounted } from 'vue';
import * as service from '@/services/usuariosService';

interface Props {
  modelValue?: number | null,
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownUsuarios',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit


var controle = reactive({
  items: [] as service.Usuario[],
  id: props.modelValue ?? null,
  text: "",
  status: ""
})

onMounted(() => {
  buscarItens();
  selecionar();
})



function selecionar() {

  var usuario = controle.items.find(c => c.usuarioId === controle.id)
  if (usuario) {
    emit('update:modelValue', usuario.usuarioId)
    emit('selected', usuario)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | null | undefined>(() => props.modelValue, (newValue) => {
  controle.id = newValue ?? null;

})


async function buscarItens() {
  try {
    controle.status = "Buscando...";

    var r = await service.obter({ tamanhoPagina: 6000 })

    controle.items = r;
    controle.status = "";
    selecionar();

  } catch (error: any) {
    console.error("Erro ao buscar itens:", error);
    controle.status = `Erro ${error.message}`;
  }
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    id: "drpVendedor",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).id) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [
    _createElementVNode("option", _hoisted_1, _toDisplayString(_unref(controle).status != null ? _unref(controle).status : '- Selecione -'), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).items, (item) => {
      return (_openBlock(), _createElementBlock("option", {
        key: item.usuarioId,
        value: item.usuarioId
      }, _toDisplayString(item.nomeCompleto) + " " + _toDisplayString(item.ativo ? '' : '(Inativo)'), 9, _hoisted_2))
    }), 128))
  ], 544)), [
    [_vModelSelect, _unref(controle).id]
  ])
}
}

})